<script setup lang="ts">
import { RouterView } from 'vue-router'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import ScrollTop from 'primevue/scrolltop'
</script>

<template>
  <div id="app">
    <RouterView />
    <Toast />
    <ConfirmDialog />
    <ScrollTop />
  </div>
</template>

<style scoped>
#app {
  min-height: 100vh;
}
</style>
